export default __webpack_public_path__ + "static/media/undraw_add_to_cart_vkjp_(1).97844540.svg";